(function () {
  var KEY = 'sakan_wishlist', AV = 'sakan_avatar';
  var WISH_URL = '/pages/wishlist', PROFILE_URL = '/pages/profile';
  var LOGGED = window.SAKAN_LOGGED_IN === true;
  function read() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} sync(); }
  function toggle(h) { var a = read(), i = a.indexOf(h); if (i > -1) a.splice(i, 1); else a.push(h); write(a); }
  function sync() {
    var a = read();
    document.querySelectorAll('[data-wish]').forEach(function (b) {
      var on = a.indexOf(b.getAttribute('data-wish')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-wish-count]').forEach(function (el) { el.textContent = a.length; el.hidden = !a.length; });
    document.querySelectorAll('[data-wish-count-text]').forEach(function (el) { el.textContent = a.length; });
  }
  function toast(msg) {
    var t = document.createElement('div'); t.textContent = msg;
    t.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#40372f;color:#fff;padding:12px 20px;border-radius:999px;z-index:99999;font-size:14px';
    document.body.appendChild(t); setTimeout(function () { t.remove(); }, 2200);
  }
  function injectLinks() {
    if (!LOGGED) return;
    [['.header-actions', 'sk-wish-link'], ['.mobile-actions', 'sk-wish-link sk-wish-link-m']].forEach(function (p) {
      var box = document.querySelector(p[0]); if (!box || box.querySelector('.sk-wish-link')) return;
      var a = document.createElement('a'); a.className = p[1]; a.href = WISH_URL; a.setAttribute('aria-label', 'المفضلة');
      a.innerHTML = (p[0] === '.header-actions' ? '<span>المفضلة</span>' : '♡') + '<b data-wish-count hidden></b>';
      var bag = box.querySelector('.bag-link'); box.insertBefore(a, bag || null);
    });
    document.querySelectorAll('.header-actions a, .mobile-actions a').forEach(function (a) {
      if (a.classList.contains('bag-link') || a.classList.contains('sk-wish-link')) return;
      a.href = PROFILE_URL;
    });
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat('ar', { style: 'currency', currency: cur }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  }
  function card(p) {
    var a = document.createElement('a'); a.className = 'sk-card'; a.href = p.url;
    var im = document.createElement('span'); im.className = 'sk-card-img';
    if (p.featured_image) { var img = document.createElement('img'); img.src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_700x$1$2'); img.alt = p.title; img.loading = 'lazy'; im.appendChild(img); }
    var b = document.createElement('button'); b.type = 'button'; b.className = 'sk-wish is-on'; b.setAttribute('data-wish', p.handle); b.setAttribute('aria-label', 'إزالة من المفضلة');
    b.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20s-7.5-4.7-9.8-9A5.3 5.3 0 0 1 12 6a5.3 5.3 0 0 1 9.8 5c-2.3 4.3-9.8 9-9.8 9z"></path></svg>';
    im.appendChild(b); a.appendChild(im);
    var info = document.createElement('span'); info.className = 'sk-card-info';
    var t = document.createElement('span'); t.className = 'sk-card-title'; t.textContent = p.title;
    var pr = document.createElement('span'); pr.className = 'sk-card-price'; pr.textContent = money(p.price);
    info.appendChild(t); info.appendChild(pr); a.appendChild(info);
    return a;
  }
  var rendering = 0;
  function renderPage() {
    var grid = document.getElementById('SakanWishGrid'); if (!grid) return;
    var empty = document.getElementById('SakanWishEmpty'), list = read(), token = ++rendering;
    if (!list.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      if (token !== rendering) return;
      var gone = [];
      items.forEach(function (p, i) { if (!p) gone.push(list[i]); });
      if (gone.length) write(read().filter(function (h) { return gone.indexOf(h) === -1; }));
      grid.innerHTML = '';
      items.filter(Boolean).forEach(function (p) { grid.appendChild(card(p)); });
      if (empty) empty.hidden = grid.children.length > 0;
      sync();
    });
  }
  window.sakanWishRender = renderPage;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (!LOGGED) { window.location.href = window.SAKAN_LOGIN_URL || '/account/login'; return; }
    var h = b.getAttribute('data-wish'), was = read().indexOf(h) > -1;
    toggle(h); toast(was ? 'تمت الإزالة من المفضلة' : 'تمت الإضافة إلى المفضلة');
    if (document.getElementById('SakanWishGrid')) renderPage();
  });
  // الصورة الشخصية (محفوظة على هذا الجهاز)
  function avatar() {
    var img = document.getElementById('SakanAvatarImg'), ini = document.getElementById('SakanAvatarInit');
    var input = document.getElementById('SakanAvatarInput'), del = document.getElementById('SakanAvatarDel');
    if (!img || !input) return;
    function show() {
      var d = null; try { d = localStorage.getItem(AV); } catch (e) {}
      if (d) { img.src = d; img.hidden = false; if (ini) ini.hidden = true; if (del) del.hidden = false; }
      else { img.hidden = true; if (ini) ini.hidden = false; if (del) del.hidden = true; }
    }
    input.addEventListener('change', function () {
      var f = input.files && input.files[0]; if (!f) return;
      var r = new FileReader();
      r.onload = function () {
        var im = new Image();
        im.onload = function () {
          var s = 256, c = document.createElement('canvas'); c.width = c.height = s;
          var m = Math.min(im.width, im.height), sx = (im.width - m) / 2, sy = (im.height - m) / 2;
          c.getContext('2d').drawImage(im, sx, sy, m, m, 0, 0, s, s);
          try { localStorage.setItem(AV, c.toDataURL('image/jpeg', 0.85)); } catch (e) { toast('تعذر حفظ الصورة'); }
          show();
        };
        im.src = r.result;
      };
      r.readAsDataURL(f);
    });
    if (del) del.addEventListener('click', function () { try { localStorage.removeItem(AV); } catch (e) {} show(); });
    show();
  }
  function init() { injectLinks(); sync(); renderPage(); avatar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
